/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Addressplaceholder1Inputs */

const en_addressplaceholder1 = /** @type {(inputs: Addressplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`123 Main St`)
};

const de_addressplaceholder1 = /** @type {(inputs: Addressplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`123 Main St`)
};

/**
* | output |
* | --- |
* | "123 Main St" |
*
* @param {Addressplaceholder1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const addressplaceholder1 = /** @type {((inputs?: Addressplaceholder1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Addressplaceholder1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_addressplaceholder1(inputs)
	return de_addressplaceholder1(inputs)
});
export { addressplaceholder1 as "addressPlaceholder" }